<script setup lang="ts">
import AtomAVideo from '@/components/atom/AVideo.vue'
import AtomImage from '@/components/atom/Image.vue'
import AtomCode from '@/components/atom/Code.vue'
import AtomGallery from '@/components/atom/Gallery.vue'

interface IMediaData {
    [key: string]: any
}

const props = defineProps<{
    mediaType: string // 'video' | 'picture' | 'code' | 'gallery'
    mediaData: IMediaData
}>()

const mediaComponent = computed(() => {
    const components: Record<string, any> = {
        video: AtomAVideo,
        picture: AtomImage,
        code: AtomCode,
        gallery: AtomGallery,
    }

    if (!components[props.mediaType]) {
        console.error(`Nieznany typ mediów: ${props.mediaType}`)
    }

    return components[props.mediaType]
})
</script>

<template>
    <div class="mx-auto mb-8 lg:mb-12">
        <component
            :is="mediaComponent"
            v-bind="mediaData"
        />
    </div>
</template>
